import ValidationRules from './ValidationRules';

export default ValidationRules;
